import { render, staticRenderFns } from "./detail-question-list.vue?vue&type=template&id=f2d68408&scoped=true&"
import script from "./detail-question-list.vue?vue&type=script&lang=js&"
export * from "./detail-question-list.vue?vue&type=script&lang=js&"
import style0 from "./detail-question-list.vue?vue&type=style&index=0&id=f2d68408&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f2d68408",
  null
  
)

export default component.exports